import { render, staticRenderFns } from "./Page403Forbidden.vue?vue&type=template&id=0621c7f1&scoped=true"
import script from "./Page403Forbidden.vue?vue&type=script&lang=js"
export * from "./Page403Forbidden.vue?vue&type=script&lang=js"
import style0 from "./Page403Forbidden.vue?vue&type=style&index=0&id=0621c7f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0621c7f1",
  null
  
)

export default component.exports